import {
    DropdownData,
    DropdownFilterContext,
    FilteredValue,
    InputType,
    Form,
    FormField,
    FormSection,
    FormType,
    ReactiveFormChangedField,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { build, list, pool } from '../../../../../common/classes/request-builder';
import { CultivosVariedadApiService } from '../../../../../service/api/cultivos-variedad-api.service';
import { VisitasApiService } from '../../../../../service/api/visitas-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../../view/base-form';
import { environment } from '../../../../../../environments/environment';

import { VariedadSIEXModel } from 'src/app/models/visitas_variedad_mes/variedadSIEX.model';
type DropdownDataWithRawData<T> = DropdownData<T> & { data?: T[] | T };
import { CultivoSIEXModel } from 'src/app/models/visitas_variedad_mes/cultivoSIEX.model';
import { catchError, map, of } from 'rxjs';
import { SeguimientoModel } from 'src/app/models/visitas/seguimiento.model';
import { FileUploadAnswer } from 'src/app/common/utils';

@Component({
    selector: 'app-viveros-pereira-form',
    standalone: false,
    templateUrl: './viveros-pereira-form.component.html',
    styleUrls: ['./viveros-pereira-form.component.scss']
})
export class ViverosPereiraFormComponent extends BaseForm<SeguimientoModel> implements OnInit {


    public override model: SeguimientoModel = {};
    public adjunto: string | ArrayBuffer | null | undefined;

    public reactiveForm!: { formType: FormType; model: Partial<SeguimientoModel>; formFields: Form<SeguimientoModel> };
  
    public distributionOrder = [
        3, 3, 3
    ];

    public cultivos: DropdownData<CultivoSIEXModel> = list<CultivoSIEXModel>(['...', null]);
    public variedades: DropdownData<VariedadSIEXModel> = list<VariedadSIEXModel>(['...', null]);
  
    public etiquetas = list(['Estudio', '1'], ['Germinación', '2'], ['Plaga', '3'], ['Deficiencia', '4'],
        ['Bloqueo', '5'], ['Deformaciones', '6'], ['Marcas', '7'], ['Alteración color', '8'], ['Marchitamiento', '9'], ['Pequeña', '10'], 
        ['Grande', '11'], ['Espigada', '12'], ['Estrechamiento cuella', '13'], ['Problema raiz', '14'], ['Mejora', '15'], ['Novedad', '16'],
        ['Error', '17'], ['Lucha biologica', '18']);

    public semanaSiembra = list<string>(['...', null]);
    public semanaEntrega = list<string>(['...', null]);

    public formFieldsLeft: FormField<any>[] = [
    {
        name: 'año',
        field: 'año',
        vinculatedFields: undefined,
        label: 'Año',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'semana',
        field: 'semana',
        vinculatedFields: undefined,
        label: 'Semana',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'fecha',
        field: 'fecha',
        vinculatedFields: undefined,
        label: 'Fecha',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
    {
        name: 'id_cultivo',
        field: 'id_cultivo',
        vinculatedFields: undefined,
        label: 'Planta',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.cultivos, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.cultivos,

        order: 4
    },
    {
        name: 'id_variedad',
        field: 'id_variedad',
        vinculatedFields: undefined,
        label: 'Variedad',
        input: {
            type: InputType.DROPDOWN_SEARCH,
            isEditable: true,
            data: this.variedades,
            dropdownConfiguration: {
                valuePrimaryKey: 'id',
                filter: (option: FilteredValue<VariedadSIEXModel>, context?: DropdownFilterContext<VariedadSIEXModel>) =>
                    this.filterVariedadByCultivo(option, context),
            },
            optionLabel: 'label',
            optionValue: 'value'
        },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.variedades,

        order: 5
    },
    {
        name: 'semana_siembra',
        field: 'semana_siembra',
        vinculatedFields: undefined,
        label: 'Semana Siembra',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.semanaSiembra, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.semanaSiembra,

        order: 6
    },
    {
        name: 'semana_entrega',
        field: 'semana_entrega',
        vinculatedFields: undefined,
        label: 'Semana Entrega',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.semanaEntrega, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.semanaEntrega,

        order: 7
    },
    {
        name: 'remesa',
        field: 'remesa',
        vinculatedFields: undefined,
        label: 'Remesa',
        input: { type: InputType.ONLY_TEXT, isEditable: false, maxLength: 4 },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 8
    },
    {
        name: 'observaciones',
        field: 'observaciones',
        vinculatedFields: undefined,
        label: 'Observaciones',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { rows: 10, hasVoiceTranscription: Boolean(true), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 9
    },
    {
        name: 'adjunto',
        field: 'adjunto',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 10
    },
];

    public formFieldsMiddle: FormField<any>[] = [
    {
        name: 'cuestiones',
        field: 'cuestiones',
        vinculatedFields: undefined,
        label: 'Cuestiones',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { rows: 10, hasVoiceTranscription: Boolean(true), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'medida',
        field: 'medida',
        vinculatedFields: undefined,
        label: 'Medida',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { rows: 10, hasVoiceTranscription: Boolean(true), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'resultados',
        field: 'resultados',
        vinculatedFields: undefined,
        label: 'Resultados',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { rows: 10, hasVoiceTranscription: Boolean(true), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
];

    public formFieldsRight: FormField<any>[] = [
    {
        name: 'etiquetas',
        field: 'etiquetas',
        vinculatedFields: undefined,
        label: 'Etiquetas',
        input: { type: InputType.MULTISELECT_SEARCH, isEditable: true, data: this.etiquetas, dropdownConfiguration: { hasMaxHeight: Boolean(true) }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.etiquetas,

        order: 1
    },
];


    private createReactiveForm(): void {
        const formType = Number(this.getType()) as FormType;
        this.reactiveForm = {
            formType,
            model: this.model,
            formFields: {
                name: 'seguimiento',
                header: this.getType() === FormType.EDITION ? this.headerTitleWhenEdit : this.headerTitleWhenNew,
                type: formType,
                sections: this.getReactiveSections(),
                table: null,
                uploadButton: { isEnabled: Boolean(false), label: '' },
                signed: Boolean(false),
            },
        };
    }

    private getReactiveSections(): FormSection<SeguimientoModel>[] {
        return [
            { name: 'Datos principales', fields: this.formFieldsLeft, width: 12, isVisible: true, order: 1 },
            { name: 'Seguimiento', fields: this.formFieldsMiddle, width: 12, isVisible: true, order: 2 },
            { name: 'Entrega', fields: this.formFieldsRight, width: 12, isVisible: true, order: 3 },
        ];
    }

    public reactiveFormChanges(
        formModel: ReactiveFormValue<SeguimientoModel>,
        lastChangedFieldName: ReactiveFormChangedField<SeguimientoModel>,
    ): void {
        this.model = { ...this.model, ...formModel } as SeguimientoModel;
        (this.formChanges as (tag?: string) => void).call(this, String(lastChangedFieldName ?? ''));
        if (this.reactiveForm) {
            this.reactiveForm.model = this.model;
        }
    }

    constructor(public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public visitasApi: VisitasApiService,
        public visitasVariedades: VisitasApiService,
        public override router: Router,
        public http: HttpClient ,
        public cultivosVariedadApi: CultivosVariedadApiService
    ) { 
        super(route,
            router,
            dashboard,
            visitasApi.visitasPereira.PUT,
            visitasApi.visitasPereira.POST ,
            'seguimiento', 
            'Editar Seguimiento',
            'Crear Seguimiento',
            'Duplicar Seguimiento'
        );
        for (let numeroSemana = 1; numeroSemana <= 52; numeroSemana++) {
            this.semanaSiembra.filtered.push({
                label: numeroSemana.toString(),
                value: numeroSemana.toString(),
            });

            this.semanaEntrega.filtered.push({
                label: numeroSemana.toString(),
                value: numeroSemana.toString(),
            });
        }
    }

    ngOnInit() {
        const date = new Date();
        this.model.año = date.getFullYear();
        this.initFormData();

        this.createReactiveForm();
        if ( this.getType() === FormType.CREATION ){
            this.model.fecha = new Date();
        }
        this.softInit(this.getType());
    
    }
  
    initFormData() {
   
        pool([
            build(this.cultivosVariedadApi.cultivosSiex.GET, this.cultivos, ['cultivo']),
            build(this.cultivosVariedadApi.variedadSiex.GET, this.variedades, ['variedad'], true),
        ], () => {
      
            this.formBuilderRef?.updateForm(this.model as unknown as Record<string, unknown>, false);
            this.finalizeExternalDropdowns();
            this.dropdownLoadTrigger.next();
        });
    }


    formChanges(tag: string){

        if (tag === 'fecha'){
            this.model.semana = this.getWeekNumberFromISOString(this.model.fecha as string);
        }
    
        if (tag === 'id_cultivo' || tag === 'id_variedad'){
            this.model.cultivo = this.resolveSelectedCultivo()?.cultivo ?? '';
            this.model.variedad = this.resolveSelectedVariedad()?.variedad ?? '';
        }

        if (tag === 'semana_siembra' || tag === 'semana_entrega'){
            const semanaSiembra = 
              this.model.semana_siembra as number < 10 ? 
                  '0' + this.model.semana_siembra : 
                  this.model.semana_siembra ? 
                      this.model.semana_siembra : '00';
            const semanaEntrega = 
              this.model.semana_entrega as number < 10 ? 
                  '0' + this.model.semana_entrega : 
                  this.model.semana_entrega ? 
                      this.model.semana_entrega : '00';
            this.model.remesa = semanaSiembra + '' + semanaEntrega;
        }
    }

    private filterVariedadByCultivo(
        option: FilteredValue<VariedadSIEXModel>,
        context?: DropdownFilterContext<VariedadSIEXModel>,
    ): boolean {
        const selectedCultivo = this.resolveSelectedCultivo(context);

        return selectedCultivo === null || option.value?.codigo_cultivo === selectedCultivo.codigo;
    }

    private resolveSelectedCultivo(
        context?: { readonly model: { get(path: string): { readonly value: unknown } | null } },
    ): CultivoSIEXModel | null {
        const currentValue = context?.model.get('id_cultivo')?.value ?? this.model['id_cultivo'];

        return this.resolveSelectedDropdownEntity(this.cultivos, currentValue);
    }

    private resolveSelectedVariedad(): VariedadSIEXModel | null {
        return this.resolveSelectedDropdownEntity(this.variedades, this.model['id_variedad']);
    }

    private resolveSelectedDropdownEntity<T>(dropdownData: DropdownDataWithRawData<T>, value: unknown): T | null {
        const allOptions = [
            ...(dropdownData.filtered ?? []),
            ...(dropdownData.values ?? []),
        ];

        for (const option of allOptions) {
            if (this.dropdownOptionMatchesValue(option, value)) {
                return this.getDropdownOptionEntity(option);
            }
        }

        if (Array.isArray(dropdownData.data)) {
            return dropdownData.data.find(item => this.entityMatchesValue(item, value)) ?? null;
        }

        if (this.entityMatchesValue(dropdownData.data, value)) {
            return dropdownData.data ?? null;
        }

        return null;
    }

    private dropdownOptionMatchesValue<T>(option: FilteredValue<T>, value: unknown): boolean {
        const tokens = this.getReactiveValueTokens(value);

        if (tokens.size === 0) {
            return false;
        }

        const entity = this.getDropdownOptionEntity(option);
        const entityId = this.getEntityId(entity);
        const optionValueId = this.getEntityId(option.value);

        return [entityId, optionValueId, option.value, option.label]
            .some(candidate => candidate !== null && tokens.has(String(candidate)));
    }

    private getDropdownOptionEntity<T>(option: FilteredValue<T>): T | null {
        if (this.isRecord(option.raw)) {
            return option.raw as unknown as T;
        }

        if (this.isRecord(option.value)) {
            return option.value;
        }

        return null;
    }

    private entityMatchesValue<T>(entity: T | undefined, value: unknown): entity is T {
        if (!this.isRecord(entity)) {
            return false;
        }

        const entityId = this.getEntityId(entity);

        return entityId !== null && this.getReactiveValueTokens(value).has(String(entityId));
    }

    private getEntityId(value: unknown): string | number | null {
        if (!this.isRecord(value)) {
            return null;
        }

        const id = value['id'];

        return typeof id === 'string' || typeof id === 'number' ? id : null;
    }

    private getReactiveValueTokens(value: unknown): Set<string> {
        const tokens = new Set<string>();
        const addToken = (candidate: unknown): void => {
            if (typeof candidate === 'string' || typeof candidate === 'number') {
                tokens.add(String(candidate));
            }
        };

        if (Array.isArray(value)) {
            value.forEach(item => {
                addToken(item);
                addToken(this.getEntityId(item));
            });

            return tokens;
        }

        addToken(value);
        addToken(this.getEntityId(value));

        return tokens;
    }

    private isRecord(value: unknown): value is Record<string, unknown> {
        return typeof value === 'object' && value !== null;
    }

    getWeekNumberFromISOString(date: string): number {
        const newYear = new Date(new Date(date).getFullYear(), 0, 1);
        let day = newYear.getDay() - 1; // the day of week the year begins on
        day = day >= 0 ? day : day + 7;
        const dayNumber: number =
      Math.floor(
          (new Date(date).getTime() -
          newYear.getTime() -
          (new Date(date).getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) /
        86400000
      ) + 1;
        let weekNumber: number;
        // if the year starts before the middle of a week
        if (day < 4) {
            weekNumber = Math.floor((dayNumber + day - 1) / 7) + 1;
            if (weekNumber > 52) {
                const nYear = new Date(new Date(date).getFullYear() + 1, 0, 1);
                let nday = nYear.getDay() - 1;
                nday = nday >= 0 ? nday : nday + 7;

                /*  if the next year starts before the middle of
             the week, it is week #1 of that year  */

                weekNumber = nday < 4 ? 1 : 53;
            }
        } else {
            weekNumber = Math.floor((dayNumber + day - 1) / 7);
        }
        return weekNumber;
    }

    // Adjuntos
    public readUrl(input: HTMLInputElement) {
        input.click();
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.adjunto = e.target?.result;
            };
            reader.readAsDataURL(input.files[0]);
            const r = this.http.post(environment.serverUrl + 'ws/seguimiento/upload_file.php', this.adjunto).subscribe(res => {
                const file = res as FileUploadAnswer;
                this.model.adjunto = file.fileName;
                r.unsubscribe();
            });
        }
    }
    public verAdjunto() {
        const myWindow = window.open('about:blank', '_blank', 'width=600, height=600');
        if (myWindow) {
            myWindow.location.assign(environment.serverUrl + 'fotos_seguimiento/' + this.model.adjunto);
            myWindow.focus();
        }
    }

    public fileChange(event: Event) {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            const fileList: FileList = input.files;
            if (fileList.length > 0) {
                const file: File = fileList[0] ?? new File([],'');
                const formData: FormData = new FormData();
                formData.append('uploadFile', file, file.name);
                const headers = new HttpHeaders();
                headers.append('Content-Type', 'multipart/form-data');
                headers.append('Accept', 'application/json');

                const name: string[] = file.name.split('.');
                const ext = name[name.length - 1];
                const accepted = ['gif', 'jpeg', 'jpg', 'jiff', 'png', 'svg', 'tiff'];
                let cond = false;

                for (const e of accepted) {
                    if (e === ext) {
                        cond = true;
                    }
                }
            
                if (cond) {
                    this.http.post<FileUploadAnswer>(
                        `${environment.serverUrl}ws/seguimiento/upload_file.php`, 
                        formData, 
                        {headers: headers}
                    ).pipe(
                        map(data => {
                            const res = data || {};
                            this.model.adjunto = res.fileName;
                        }),
                        catchError(error => {
                            console.log(error);
                            return of(null);
                        })
                    ).subscribe();
                } else {
                    alert('Formato de imágen no válido.');
                    this.model.adjunto = '';
                }
            }
        }
    }
}